'use client';

import type { ApolloQueryResult } from '@apollo/client';
import { createContext, type FC, type PropsWithChildren, useEffect, useRef } from 'react';
import type { TariffsQuery } from '../../types/generated';

export const Context = createContext<Promise<ApolloQueryResult<TariffsQuery>> | null>(null);

export const ElectricityTariffsContext: FC<
  PropsWithChildren & {
    tariffs: Promise<ApolloQueryResult<TariffsQuery>> | null;
  }
> = ({ children, tariffs }) => {
  const cachedTariffs = useRef(tariffs);

  useEffect(() => {
    if (tariffs !== null) {
      cachedTariffs.current = tariffs;
    }
  }, [tariffs]);

  return <Context.Provider value={cachedTariffs.current}>{children}</Context.Provider>;
};
